import Login from '../../components/Auth/Login';
function LoginPage() {
    return <Login />;
}
export default LoginPage;